// extracted by mini-css-extract-plugin
module.exports = {"hr":"_payment-Hr-module--hr--6Ral2"};